import { Fragment, useEffect, useState, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux"
import { Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import themeConfig from '../../configs/themeConfig'
import { RegenerateAuthorizationLetter, ValidateWorkorderCreation, ResendPendingDocumentsToVault, GenerateCRA } from '../redux/store'
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import { isUserLoggedIn } from '@utils'

const MoreActionss = [{ value: 1, label: 'Delete Work Order', status: 1 }, { value: 2, label: 'Deactivate Work Order', status: 2 }, { value: 3, label: 'Add/Update Billing Prefix', status: 3 }, { value: 4, label: 'Resend Email', status: 4 }, { value: 5, label: 'Regenerate Document', status: 5 }, { value: 6, label: "Create IC-Amendment ", status: 6 }, { value: 7, label: 'Suspend Work Order', status: 7 }, { value: 8, label: 'Regenerate Certificate', status: 8 }, { value: 9, label: "Cancel & Replace Invoice", status: 9 }, { value: 11, label: "Reject Work Order", status: 11 }, { value: 12, label: "Generate CRA", status: 12 }, { value: 13, label: "Void Work Order", status: 13 }]

const MoreActions = (props) => {
  const dispatch = useDispatch()
  const { catCode } = useParams()
  const { typeCode } = useParams()
  const navigate = useNavigate()
  const { woId } = useParams()
  const { openCancelModal, status, woIData, setgLoader, isValutPassing } = props
  const stores = useSelector((state) => state.commonreducerSlice)

  // ** States
  const [MoreActionsData, setMoreActionsData] = useState([])
  const [moreActionValue, setMoreActionValue] = useState(null)
  const [spinnerCreate, setSpinnerCreate] = useState(true)
  const [open, setOpen] = useState(false)
  const container = useRef(null)
  const [dopen, setDOpen] = useState(false)

  useEffect(() => {
    if (status && stores?.enableAction) {
      let buffer = []
      if (isValutPassing) {
        buffer = [...MoreActionss, { value: 10, label: "Re Migrate Document", status: 10 }]
      } else {
        buffer = [...MoreActionss]
      }
      if (catCode === 'FA' && (typeCode === 'CAP' || typeCode === "SAP")) {
        buffer = buffer.map(item => (item.value === 2 ? { ...item, label: typeCode === 'CAP' ? "Cancel Application" : "Cancel Work Order" } : item))
      }
      setMoreActionsData(buffer.filter((obj) => status.includes(obj.status)))
    } else {
      const userData = isUserLoggedIn()
      let buffer = []
      const userRoles = userData && userData.userRoles
      const role = userRoles.find(find => find.rId === 3 || find.rId === 5 || find.rId === 8)
      if (role) {
        if (catCode === 'FA' && (typeCode === 'CAP' || typeCode === "SAP")) {
          buffer = [...MoreActionss]
          const tempBuffer = status
          buffer = buffer.map(item => (item.value === 2 ? { ...item, label: typeCode === 'CAP' ? "Cancel Application" : "Cancel Work Order" } : item))
          if (typeCode === "CAP") {
            tempBuffer.push(2)
          } else {
            tempBuffer.push(2)
            tempBuffer.push(11)
            tempBuffer.push(13)
          }
          setMoreActionsData(buffer.filter((obj) => tempBuffer.includes(obj.status)))
        }
      }
    }
  }, [status])

  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    setRefreshKey(prev => prev + 1)
    if (moreActionValue) {
      if (moreActionValue.value === 1) {
        openCancelModal('Cancel')
      } else if (moreActionValue.value === 2) {
        openCancelModal('Archive')
      } else if (moreActionValue.value === 11) {
        openCancelModal('Reject')
      } else if (moreActionValue.value === 13) {
        openCancelModal('Void')
      } else if (moreActionValue.value === 3) {
        openCancelModal('Add/Update Billing Prefix')
      } else if (moreActionValue.value === 4) {
        openCancelModal('Resend Email')
      } else if (moreActionValue.value === 7) {
        openCancelModal('Suspend')
      } else if (moreActionValue.value === 5) {
        openCancelModal('RegenerateDocument')
        setgLoader(true)
        async function fetchCall() {
          await dispatch(RegenerateAuthorizationLetter({ ccode: catCode, tcode: typeCode, woId, status: moreActionValue.value }))
          setgLoader(false)
          openCancelModal('')
        }
        fetchCall()
      } else if (moreActionValue.value === 12) {
        openCancelModal('RegenerateDocument')
        // setgLoader(true)
        async function fetchCall() {
          await dispatch(GenerateCRA({ ccode: catCode, tcode: typeCode, woId, status: moreActionValue.value }))
          // setgLoader(false)
          openCancelModal('')
        }
        fetchCall()
      } else if ((moreActionValue.value === 8)) {
        openCancelModal('RegenerateDocument')
        setgLoader(true)
        async function fetchCall() {
          const respDa = await dispatch(RegenerateAuthorizationLetter({ ccode: catCode, tcode: typeCode, woId, status: moreActionValue.value }))
          setgLoader(false)
          openCancelModal('')
          if (respDa) {
            if (respDa.payload) {
              const respData = respDa.payload.data
              if (respData) {
                if (respData.fileContent) {
                  const linkSource = `data:${respData.contentType};base64,${respData.fileContent}`
                  const downloadLink = document.createElement("a")
                  const fileName = respData.fileName
                  downloadLink.href = linkSource
                  downloadLink.download = fileName
                  downloadLink.click()
                }
              }
            }
          }
        }
        fetchCall()
      } else if (moreActionValue.value === 6) {
        const dataToStore = { ihmCompanyId: woIData.companyId, imoNumber: woIData?.workorderData?.application?.imoNumber }
        sessionStorage.setItem("CreateIcaData", JSON.stringify(dataToStore))
        async function fetchCall2() {
          setSpinnerCreate(true)
          const obj = {
            type: "ICA",
            categoryId: catCode,
            companyId: woIData.companyId ? woIData.companyId : null
          }
          const responseData = await dispatch(ValidateWorkorderCreation(obj))
          if (responseData.payload) {
            setSpinnerCreate(false)
            const data = responseData.payload.data
            if (data && data.workorderValidationMessage === undefined) {
              if (woId || catCode) {
                setSpinnerCreate(true)
                navigate('/pageRefresh')
                setTimeout(() => {
                  if (data.woId && data.woId > 0) {
                    navigate(`/${catCode}/ICA/${data.woId}`)
                  } else {
                    navigate(`/${catCode}/ICA/save`)
                  }
                }, 2000)
              } else {
                setSpinnerCreate(true)
                if (data.woId && data.woId > 0) {
                  navigate(`/${catCode}/ICA/${data.woId}`)
                } else {
                  navigate(`/${catCode}/ICA/save`)
                }
              }
            } else if (data.workorderValidationMessage) {
              setSpinnerCreate(true)
            }
          }

        }
        fetchCall2()
      } else if (moreActionValue.value === 9) {
        openCancelModal('Replace Invoice')
      }
      if (isValutPassing && moreActionValue.value === 10) {
        async function fetchData() {
          const response = await dispatch(ResendPendingDocumentsToVault({ ccode: catCode, tcode: typeCode, parentWoId: (typeCode === "CAP" ? stores?.woIdData?.application?.applicationInformation?.woId : stores?.woIData?.id) }))
          if (response.payload.data) {
            const bufferData = [...MoreActionsData].filter((item) => item?.label !== "Re Migrate Document")
            setMoreActionsData(bufferData)
          } else {

          }
        }
        fetchData()
      }
      setMoreActionValue(null)
    }
  }, [moreActionValue])

  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const handleMouseEnter = () => {
    setOpen(true)
    setDOpen(false)
  }

  const handleMouseLeave = () => {
    setOpen(false)
    setDOpen(false)
  }

  const handleMouseEnterDrop = () => {
    setDOpen(true)
  }

  return (
    <div key={refreshKey}>
      <ul className="nav navbar-nav">
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item dropdown-create" onMouseLeave={handleMouseLeave}>
          <DropdownToggle
            href="/"
            tag="a"
            className="nav-link dropdown-user-link p-0"
            onClick={(e) => e.preventDefault()}
            onMouseEnter={handleMouseEnter}
          >
            <Button.Ripple color='primary' style={{ padding: '12px 20px' }}>
              {open ? (
                <Fragment>
                  {dopen ? (
                    <img src={themeConfig.navicons.more1} alt='More Actions' className='more_action_svg_icon' />
                  ) : (
                    <img src={themeConfig.navicons.more} alt='More Actions' className='more_action_svg_icon' />
                  )}
                </Fragment>
              ) : (
                <img src={themeConfig.navicons.more1} alt='More Actions' className='more_action_svg_icon' />
              )}
              <span className='align-middle d-sm-inline-block d-none mx-50'>More Actions</span>
            </Button.Ripple>
          </DropdownToggle>
          <DropdownMenu end className={open ? 'show' : 'hide'} style={{ position: 'absolute', transform: 'scale(1,1)', bottom: '40px' }}>
            {MoreActionsData.length > 0 ? (
              MoreActionsData.map((item, index) => {
                if (item.label === "Create Work Order") {
                  return (
                    <DropdownItem key={index}
                      onMouseEnter={handleMouseEnterDrop}
                      onClick={() => {
                        setOpen(!open)
                        setMoreActionValue(item)
                      }}>
                      {spinnerCreate ? <span className="align-middle"> {item.label}</span> : <ComponentSpinner></ComponentSpinner>}
                    </DropdownItem>
                  )
                } else {
                  return (
                    <DropdownItem key={index}
                      onMouseEnter={handleMouseEnterDrop}
                      onClick={() => {
                        setOpen(!open)
                        setMoreActionValue(item)
                      }}>
                      <span className="align-middle">{item.label}</span>
                    </DropdownItem>
                  )
                }
              })

            ) : <DropdownItem disabled className="text-center text-danger">
              You don't have work order access
            </DropdownItem>
            }
          </DropdownMenu>
        </UncontrolledDropdown>
      </ul>

      <div onMouseLeave={handleMouseLeave} className='more_actions d-none'>
        <Button
          color='info'
          className='btn-prev'
          onMouseEnter={handleMouseEnter}
          onClick={() => setOpen(!open)}
        >
          <img src={themeConfig.navicons.more} alt='More Actions' className='more_action_svg_icon' />
          <span className='align-middle d-sm-inline-block d-none mx-50'>More Actions</span>
        </Button>
        {open && (
          <div className="dropdown-wrapper-db-more-actions"
            style={{ right: '365px', marginLeft: 0 }}
            onMouseEnter={handleMouseEnter}>
            <ul className="dropdown-menu-db-more-actions">
              {MoreActionsData.map((item) => (
                <li
                  className='dropdown-menu-db__item-more-actions'
                  key={item.value}
                  onClick={() => {
                    setOpen(!open)
                    setMoreActionValue(item)
                  }
                  }>{item.label}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div >

  )
}

export default MoreActions
